/**
 * Custom PDP Buy-Box Wrapper
 *
 * This script wraps the product title, price, and buy buttons
 * in a single visual buy-box container.
 *
 * This file is update-safe (won't be overwritten by theme updates).
 */

(function() {
  function createBuyBox() {
    // Check if buy-box already exists
    if (document.querySelector('.custom-buy-box-wrapper')) {
      return;
    }

    // Find the key elements
    var titleElement = document.querySelector('.product-details-product-title');
    var buyButtonsWrapper = document.querySelector('.paymentButtonsWrapper');

    if (!titleElement || !buyButtonsWrapper) {
      return;
    }

    // Get the parent containers (product-form-block divs)
    var titleBlock = titleElement.closest('.product-form-block');
    var buyButtonsBlock = buyButtonsWrapper.closest('.product-form-block');

    if (!titleBlock || !buyButtonsBlock) {
      return;
    }

    // Find the common parent
    var parent = titleBlock.parentElement;

    // Get all sibling elements
    var allChildren = Array.from(parent.children);

    var titleIndex = allChildren.indexOf(titleBlock);
    var buyButtonsIndex = allChildren.indexOf(buyButtonsBlock);

    if (titleIndex === -1 || buyButtonsIndex === -1 || titleIndex > buyButtonsIndex) {
      return; // Invalid order or not found
    }

    // Create the buy-box wrapper
    var buyBoxWrapper = document.createElement('div');
    buyBoxWrapper.className = 'custom-buy-box-wrapper';

    // Insert the wrapper before the title block
    parent.insertBefore(buyBoxWrapper, titleBlock);

    // Move all elements from title to buy buttons into the wrapper
    // Note: We need to collect elements first since moving changes indices
    var elementsToMove = [];
    for (var i = titleIndex; i <= buyButtonsIndex; i++) {
      elementsToMove.push(allChildren[i]);
    }

    elementsToMove.forEach(function(el) {
      buyBoxWrapper.appendChild(el);
    });
  }

  // Run when DOM is ready and also observe for dynamic changes
  function init() {
    createBuyBox();

    // Also observe for any dynamic loading
    var observer = new MutationObserver(function() {
      if (!document.querySelector('.custom-buy-box-wrapper')) {
        createBuyBox();
      }
    });

    var productForm = document.querySelector('.product--add-to-cart-form, .form-vertical');
    if (productForm) {
      observer.observe(productForm, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// ─── Discount-Badge auf Anzahl-Swatches ──────────────────────────────────────
(function() {
  function calcDiscount(variant) {
    if (!variant.compare_at_price || variant.compare_at_price <= variant.price) return null;
    var pct = Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100);
    return pct > 0 ? '-' + pct + '%' : null;
  }

  function applyBadges(variants) {
    document.querySelectorAll('[data-option="Anzahl"]').forEach(function(swatchEl) {
      if (swatchEl.querySelector('.swatch-discount-badge')) return;

      var variantId = swatchEl.getAttribute('data-swatch-variant-id');
      if (!variantId) return;

      var variant = null;
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === variantId) { variant = variants[i]; break; }
      }
      if (!variant) return;

      var discountText = calcDiscount(variant);
      if (!discountText) return;

      var badge = document.createElement('span');
      badge.className = 'swatch-discount-badge';
      badge.textContent = discountText;
      swatchEl.appendChild(badge);
    });
  }

  function init() {
    if (document.body.getAttribute('data-swatch-discount-badges') !== 'true') return;
    if (!document.querySelector('.product-single')) return;

    var firstSwatch = document.querySelector('[data-option="Anzahl"]');
    if (!firstSwatch) return;

    // Mark product as having Anzahl swatches – used by CSS to hide the image badge
    document.querySelector('.product-single').classList.add('has-anzahl-swatches');

    var firstInput = firstSwatch.querySelector('input[data-product-fetch-url]');
    var fetchUrl = firstInput ? firstInput.getAttribute('data-product-fetch-url') : '';
    var match = fetchUrl.match(/\/products\/([^?/]+)/);
    if (!match) return;

    fetch('/products/' + match[1] + '.js')
      .then(function(res) { return res.json(); })
      .then(function(product) {
        applyBadges(product.variants);

        // Re-apply whenever Anzahl swatches are added to the DOM.
        // This covers both regular swatch clicks (variant:updated path) and
        // image-scroll variant changes (fromSlideChange path, which skips variant:updated).
        new MutationObserver(function(mutations) {
          var hasAnzahlNodes = mutations.some(function(m) {
            return Array.from(m.addedNodes).some(function(node) {
              return node.nodeType === 1 && (
                node.matches('[data-option="Anzahl"]') ||
                (node.querySelector && node.querySelector('[data-option="Anzahl"]'))
              );
            });
          });
          if (!hasAnzahlNodes) return;
          applyBadges(product.variants);
        }).observe(document.body, { childList: true, subtree: true });
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
